<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <tp-table
        :isNeedSerialNumber="false"
        :isCheckBox="false"
        :tableData="list"
        :columns="columns"
        :is-page="0"
    />
    <el-dialog
        title="消息模板配置"
        :visible.sync="dialogVisible"
        width="70%"
        @close="onClose"
    >
      <el-form ref="form" :model="formData" label-width="120px">
        <el-form-item label="模板内容" :rules="[{ required: true, message: '请输入模板内容' }]">
          <el-input
              v-model="formData.tplContent"
              placeholder="请输入提醒内容"
              style="width: 400px"
              type="textarea"
              :autosize="{ minRows: 8, maxRows: 10 }"
              maxlength="200"
              show-word-limit
              word-limit-position="outside"
          />
        </el-form-item>
        <el-form-item label="提醒时间" :rules="[{ required: true, message: '请输入提醒时间' }]">
          <el-time-select
              v-model="formData.remindTime"
              style="width: 240px"
              placeholder="请选择执行时间"
              :picker-options="{
                start: '09:00',
                step: '00:30',
                end: '11:30',
              }"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onClose">取消</el-button>
        <el-button type="primary" size="small" @click="onSubmit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {getMsgTplListAPI, getMsgTplDetailAPI, editMsgTplStatusAPI, editMsgTplAPI,} from './api';
const columns = [
  {
    label: "ID",
    prop: "id",
    minWidth: "80",
    customRender(h, row) {
      return <p>{row["id"]}</p>;
    },
  },
  {
    label: "模板类型",
    prop: "tplTypeName",
    minWidth: "150",
    customRender(h, row) {
      return <p>{row["tplTypeName"]}</p>;
    },
  },
  {
    label: "模板内容",
    prop: "tplContent",
    minWidth: "200",
    customRender(h, row) {
      return <p>{row["tplContent"]}</p>;
    },
  },
  {
    label: "提醒状态",
    prop: "remindStatus",
    minWidth: "100",
    customRender(h, row) {
      return (
          <div>
            <el-switch
                class="switch"
                onChange={() => this.changeStatus(row)}
                v-model={row["remindStatus"]}
                active-value={true}
                inactive-value={false}
            ></el-switch>
          </div>
      );
    },
  },
  {
    label: "提醒时间",
    prop: "remindTime",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["remindTime"]}</p>;
    },
  },
  {
    label: "操作",
    minWidth: "80",
    fixed: "right",
    customRender(h, row) {
      return (
          <div>
            <el-link
                underline={false}
                type="primary"
                onClick={() => this.handleEdit(row['id'])}
            >
              编辑
            </el-link>
          </div>
      );
    },
  },
];
export default {
  name: 'WxcpMsgTplList',
  data() {
    return {
      list: [],
      columns,
      dialogVisible: false,
      formData: {
        id: '',
        tplContent: '',
        remindTime: '',
      }
    }
  },
  provide() {
    return {
      context: this
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      this.list = await getMsgTplListAPI();
    },
    changeStatus(row) {
      let { id, remindStatus } = row;
      let data = { id, remindStatus };
      let statusDesc = remindStatus ? "启用" : "禁用";
      this.$confirm(`此操作将${statusDesc}该模板, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            row.remindStatus = remindStatus;
            editMsgTplStatusAPI(data).then(() => {
              this.getList();
              this.$message.success("操作成功");
            });
          })
          .catch(() => {
            row.remindStatus = !remindStatus;
            this.$message({
              type: "info",
              message: "已取消操作",
            });
          });
    },
    async handleEdit(id) {
      this.formData = await getMsgTplDetailAPI(id);
      this.dialogVisible = true;
    },
    onClose() {
      this.formData.id = '';
      this.formData.tplContent = '';
      this.formData.remindTime = '';
      this.dialogVisible = false;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          editMsgTplAPI(this.formData).then(() => {
            this.getList();
            this.$message.success("操作成功");
            this.onClose();
          });
        }
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.wrapper {
  width: 100%;
  .el-form {
    .el-form-item {
      .el-input {
        width: 500px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.wrapper /deep/ {
}
</style>